export default "__VITE_ASSET__Bi$IJtiy__"